<template>
  <Menu v-if="locales" v-slot="{ close }" as="div" class="relative mx-2 lg:flex-shrink-0">
    <div class="flex">
      <MenuButton
        v-if="brandconfig.lang?.length && brandconfig.lang.length > 1"
        class="relative flex text-base font-bold bg-white p-1 px-2 rounded-full">
        <div class="rounded-full">
          <CountryFlag :code="LOCALES[$i18n.locale]?.flag" />
        </div>
        <ChevronDownIcon class="h-4 self-center ml-1 stroke-2 stroke-black" />
      </MenuButton>
    </div>

    <MenuItems
      class="fixed w-full h-auto mt-5 lg:w-auto lg:h-auto lg:absolute lg:flex flex-col right-0 z-20 origin-top-right lg:rounded-md bg-background text-foreground lg:shadow-lg lg:ring-1 lg:ring-black/5 overflow-hidden focus:outline-none">
      <div class="flex justify-between">
        <h3 class="text-xl font-bold px-4 py-2">{{ $t("Language") }}</h3>
        <button class="lg:hidden mr-5" @click="close">
          <XMarkIcon class="h-5" />
        </button>
      </div>
      <hr />
      <div class="py-2">
        <MenuItem v-for="locale of locales" :key="locale" v-slot="{ active }">
          <button class="w-full" :class="{ 'bg-primary text-btn-forecolor': active }" @click="switchLocale(locale)">
            <div class="px-4 py-2 text-left flex min-w-max justify-between gap-2 items-center">
              <CountryFlag small :code="LOCALES[locale]?.flag" :country="LOCALES[locale]?.title" />
              <span class="grow">{{ LOCALES[locale]?.title }}</span>
              <CheckIcon v-if="$i18n.locale === locale" class="w-5" />
            </div>
          </button>
        </MenuItem>
      </div>
    </MenuItems>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { CheckIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import brandconfig from "@/brandconfig";
import CountryFlag from "@/components/CountryFlag.vue";
import { setLocale } from "@xs2event/js-lib/util";
import { LOCALES, locales } from "./locales.js";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";

import { useUserStore } from "@/store/user.js";
import { isB2C } from "@/brandconfig";
import { i18n } from "../../../i18n.ts";
import { useEventStore } from "@/store/event.js";
import { useCartStore } from "@/store/cart.ts";

const cartStore = useCartStore();
const eventStore = useEventStore();
const userStore = useUserStore();

const switchLocale = (option) => {
  if (isB2C) {
    setLocale((i18n.locale = option));
  } else {
    if (userStore.client_id) {
      if (!!cartStore.items.length > 0) {
        updateCartLocale(option);
      } else {
        userStore.updateLocale(option);
        setLocale(option);
      }
    } else {
      setLocale(option);
    }
  }
};

const updateCartLocale = (option) => {
  let cartItems = [];
  userStore.updateLocale(option).then(() => {
    cartItems = JSON.parse(localStorage[userStore.client_id]).items;
    cartItems.forEach((item) => {
      eventStore
        .fetchPreferredLanguageEvent(item.event.event_id, option)
        .then((res) => {
          item.event.event_name = res.event_name;
        })
        .then(() => {
          delete localStorage[userStore.client_id];
          localStorage[userStore.client_id] = JSON.stringify(cartItems);
          cartStore.items = cartItems;
          cartStore.updateReservation();
          setLocale(option);
        });
    });
  });
};
</script>
